"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSyntaxValid = exports.fromStringOrEmpty = exports.fromString = exports.isValidMatchMissing = exports.isValid = exports.getReferencedProperties = exports.equals = exports.Empty = void 0;
const uom_1 = require("@genesys/uom");
const property_1 = require("@promaster-sdk/property");
const PropertyCompare = __importStar(require("./property-compare"));
var property_filter_1 = require("@promaster-sdk/property/lib/property-filter");
Object.defineProperty(exports, "Empty", { enumerable: true, get: function () { return property_filter_1.Empty; } });
Object.defineProperty(exports, "equals", { enumerable: true, get: function () { return property_filter_1.equals; } });
Object.defineProperty(exports, "getReferencedProperties", { enumerable: true, get: function () { return property_filter_1.getReferencedProperties; } });
Object.defineProperty(exports, "toString", { enumerable: true, get: function () { return property_filter_1.toString; } });
const isValid = (pvs, filter) => property_1.PropertyFilter.isValid(pvs, filter, PropertyCompare.compare);
exports.isValid = isValid;
const isValidMatchMissing = (pvs, filter) => property_1.PropertyFilter.isValidMatchMissing(pvs, filter, PropertyCompare.compare);
exports.isValidMatchMissing = isValidMatchMissing;
const fromString = (filter) => property_1.PropertyFilter.fromString(filter.toLowerCase(), uom_1.unitLookup);
exports.fromString = fromString;
const fromStringOrEmpty = (filterString) => property_1.PropertyFilter.fromStringOrEmpty(filterString.toLowerCase(), uom_1.unitLookup);
exports.fromStringOrEmpty = fromStringOrEmpty;
const isSyntaxValid = (filter, propertyNames) => property_1.PropertyFilter.isSyntaxValid(filter.toLowerCase(), uom_1.unitLookup, propertyNames);
exports.isSyntaxValid = isSyntaxValid;
//# sourceMappingURL=property-filter.js.map